/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import ConsentingJournalComponent from './consenting.journal.component';
import DocumentsService from '../documents/documents.service';
import {
  showModal,
  journalDocumentSelected,
  fetchConsentingJournal,
  fetchJournalPdf,
  clearJournalForm,
  fetchParticipantJournal,
  fetchParticipantJournalPDF
} from '../../actions/actions.js';
import { MODAL_TYPE_FLAG } from '../../constants/modalTypes';
import SubjectService from '../subject/subject.service';

export const mapStateToProps = (state) => {
  let [timezone] = SubjectService.getSiteTimezone(state.subject.participantSites);
  return {
    participantId: state.subject.participantJourney.userId,
    participantJourneyGid: state.subject.participantJourney.gid,
    documentsMetadata: DocumentsService.prepareDocumentsMetadata(state.documents.items).documentsMetadata,
    consentingGid: state.consentingJournal.consentingGid,
    consentGid: state.consentingJournal.consentGid,
    error: state.consentingJournal.error,
    response: state.consentingJournal.response,
    isFetching: state.consentingJournal.isFetching,
    isFetchingPdf: state.consentingJournal.isFetchingPdf,
    timezone
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    journalDocumentSelectionChanged: (consentingGid) => {
      dispatch(journalDocumentSelected(consentingGid));
      dispatch(fetchConsentingJournal(consentingGid));
    },

    fetchJournalPdf: (consentingGid) => {
      dispatch(fetchJournalPdf(consentingGid));
    },

    resetForm: () => {
      dispatch(clearJournalForm());
    },

    fetchParticipantJournal: (participantJourneyGid) => {
      dispatch(fetchParticipantJournal(participantJourneyGid));
    },

    fetchParticipantJournalPDF: (participantJourneyGid) => {
      dispatch(fetchParticipantJournalPDF(participantJourneyGid));
    },
    openFlagModal: (content, title) => {
      dispatch(
        showModal(MODAL_TYPE_FLAG, {
          shouldCloseOnOverlayClick: false,
          title,
          details: '',
          className: 'flag-modal',
          props: { content }
        })
      );
    }
  };
};

const ConsentingJournalContainer = connect(mapStateToProps, mapDispatchToProps)(ConsentingJournalComponent);

export default ConsentingJournalContainer;
